import CustomPaletteProvider from './provider'

export default {
    __init__: [ 'customPaletteProdiver'],
    customPaletteProdiver: [ 'type', CustomPaletteProvider ]
}